var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DownloadCard',{attrs:{"i18nPrefix":"components.standaloneDownloadCard","checkboxes":_vm.checkboxes,"loading":_vm.standaloneVersions.length === 0,"versions":_vm.standaloneVersions,"betaVersions":_vm.standaloneBetaVersions}})}
var staticRenderFns = []

export { render, staticRenderFns }